let utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'master-supplier-detail',
  created () {
    this.getSupplier()
  },
  data () {
    return {
      supplier: {
        name: '',
        name_hurigana: '',
        responsible_name: '',
        tel_no: '',
        fax_no: '',
        mail: '',
        postal_code: '',
        address: '',
        order_method: '',
        fee_type: 'no_fee'
      }
    }
  },
  computed: {
    displayOrderMethod () {
      if (this.supplier.order_method == 'fax') {
        return 'FAX'
      } else if (this.supplier.order_method == 'email') {
        return 'email'
      } else if (this.supplier.order_method == 'tanomail') {
        return 'たのめーる'
      }
    },
    displayFeeType () {
      if (this.supplier.fee_type == 'no_fee') {
        return '手数料なし'
      } else if (this.supplier.fee_type == 'zero_infinity') {
        return 'ゼロインフィニティ'
      }
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getSupplier () {
      let res = await this.$store.dispatch('GET_SUPPLIER', {id: this.$route.params.id})
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })

      this.supplier = res.supplier
    },
    onClickCancel () {
      this.$router.push('/master_supplier_list')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-supplier-detail.js